import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import { initializeServiceWorker, ServiceWorkerManager } from './utils/serviceWorkerIntegration';
import { arrayBufferTracker } from './utils/memory-leak-tracker';

// 🔧 DECLARAÇÃO TYPESCRIPT: Service Worker
declare global {
  interface Window {
    __serviceWorkerRegistration?: ServiceWorkerRegistration;
    __serviceWorkerManager?: ServiceWorkerManager;
  }
}

// 🚀 Inicializar Service Worker com Error Boundary Global
const initApp = async () => {
  try {
    
    // Registrar Service Worker com error boundary
    const swRegistered = await initializeServiceWorker();
    
    if (swRegistered) {
      
      // Adicionar referência global para debug
      const swManager = ServiceWorkerManager.getInstance();
      if (typeof window !== 'undefined') {
        window.__serviceWorkerManager = swManager;
      }
      
    } else {
      console.warn('⚠️ [PMC Web] Service Worker não pôde ser registrado');
    }
    
    // Inicializar ArrayBuffer leak tracker
    arrayBufferTracker.init();
    
  } catch (error) {
    console.error('❌ [PMC Web] Erro na inicialização:', error);
  }
  
  // Renderizar a aplicação
  ReactDOM.render(<App />, document.getElementById('root'));
};

// 🧹 Cleanup quando página fechar
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    const swManager = window.__serviceWorkerManager;
    if (swManager) {
      // Cleanup automático já é feito pelo SW
    }
  });
  
  // Debug helpers para desenvolvimento
  if (process.env.NODE_ENV === 'development') {
    window.addEventListener('keydown', (event) => {
      // Ctrl+Shift+R: Forçar atualização do SW
      if (event.ctrlKey && event.shiftKey && event.code === 'KeyR') {
        event.preventDefault();
        const swManager = window.__serviceWorkerManager;
        if (swManager) {
          swManager.forceUpdate();
        }
      }
      
      // Ctrl+Shift+E: Limpar cache de erros
      if (event.ctrlKey && event.shiftKey && event.code === 'KeyE') {
        event.preventDefault();
        const swManager = window.__serviceWorkerManager;
        if (swManager) {
          swManager.clearErrorCache();
        }
      }
    });
    
    // Helper global para debug
    (window as any).pmcDebug = {
      getServiceWorkerStatus: () => {
        const swManager = window.__serviceWorkerManager;
        return swManager ? swManager.getStatus() : null;
      },
      forceUpdate: () => {
        const swManager = window.__serviceWorkerManager;
        if (swManager) swManager.forceUpdate();
      },
      clearErrors: () => {
        const swManager = window.__serviceWorkerManager;
        if (swManager) swManager.clearErrorCache();
      }
    };
    
  }
}

// Inicializar a aplicação
initApp();
